module.exports = __webpack_public_path__ + "fonts/TiemposFineWeb-Semibold.368d758d.woff2";